
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Search from 'vux/src/components/search/index.vue'


export default {
name: "assistant",
components: {Search, Group, Cell},
data() {
return {
header: {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
},
nameList: [],
name: '',
seq: this.$route.query.seq,
role: this.$route.query.role,
type: this.$route.query.type,
isSearch: false
}
},
methods: {
onFocus() {
this.isSearch = true
},
onCancel() {
this.isSearch = false
},
setFocus() {
this.$refs.search.setFocus()
},
resultClick(userid) {
this.$vux.confirm.show({
title: '',
content: '确认添加该专家为协助人',
onConfirm: () => {
this.$http.post('/api/v1/normalrepairs/' + this.seq + '/set_repair_visible_to', {
role: this.role,
userid: userid.toString(),
user_type: 'EXPT',
visible: true
}, this.header).then(() => {
if (this.role === 'EXPT') {
this.$router.push({name: 'records', query: {seq: this.seq}})
} else {
this.$router.push({name: 'RepairSrvp', query: {seq: this.seq, role: 'SRVP', type: this.type}})
}
}).catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).faultstring,
type: 'cancel',
time: '1000'
})
})
}
})
},
getResult(val) {
if (this.role === 'EXPT') {
this.$http.get('/api/v1/experts/' + localStorage.getItem('userid') + '/list_my_colleagues?hint=' + val + '&offset=0&count=999', this.header)
.then(response => {
this.nameList = response.data.list
})
} else {
this.$http.get('/api/v1/agencies/' + localStorage.getItem('userid') + '/experts?hint=' + val + '&offset=0&count=9999&type=added', this.header)
.then(response => {
this.nameList = response.data.list
});
}
},
},
created() {
this.getResult('')
}
}



// WEBPACK FOOTER //
// ./src/components/assistantinfo/assistant.vue